var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.shouldDisplay())?_c('a',{staticClass:"LeaderboardAd",attrs:{"href":this.imageLink()}},[_c('img',{staticClass:"column is-record-ad is-hidden-mobile has-text-centered",attrs:{"src":this.imageSrc(),"alt":"advertisemnt"}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }